import { ViewFilters } from "web/components"
import { useState } from "react"
import { Input } from "web/components/Form/Controls"
import TileSizeSelectors from "../../SharedModalComponents/TileSizeSelectors"
import ChartViewSelectors from "./ChartViewSelectors"
import TileWizardActions from "web/components/AddTileWizard/TileWizardActions"

export default function TileChartSettingsModal({
  backButtonHandler,
  groupFieldData,
  intialChartTileSetting,
  kindFieldData,
  saveChartTileSettingsHandler,
  tile: chartTile,
  weightFieldData,
  overviewType,
}) {
  const [title, setTitle] = useState({ value: chartTile.name })

  const [chartSettingValues, setChartSettingValues] = useState(
    intialChartTileSetting
  )
  const chartSettingValuesHandler = (settingKey, settingValue) => {
    setChartSettingValues((state) => ({ ...state, [settingKey]: settingValue }))
  }

  const saveChartTileSettings = () => {
    saveChartTileSettingsHandler({ ...chartSettingValues, title })
  }

  return (
    <>
      <div className="modal-content-above-commands">
        <div className="grid gap-y-5">
          <Input label="Title" value={title} onChange={setTitle} />
          <TileSizeSelectors
            limitTileSizeOptions={{ width: 2, height: 0 }}
            tileWidth={{ value: chartSettingValues.width }}
            tileHeight={{ value: chartSettingValues.height }}
            setTileHeight={({ value }) =>
              chartSettingValuesHandler("height", value)
            }
            setTileWidth={({ value }) =>
              chartSettingValuesHandler("width", value)
            }
          />
        </div>
        <div className="mb-6 mt-6 rounded-md border px-4 py-4 shadow-sm">
          <div className="mb-1 text-lg font-bold">Filters</div>
          <div className="mb-3">
            {overviewType === "viewable" && (
              <div className="text-sm italic">
                Filters applied to this chart will override the existing
                filter(s) currently applied to your Overview
              </div>
            )}
            <ViewFilters
              availableFields={chartTile.available_fields}
              containerClasses="my-2 md:my-3"
              filterConditions={chartTile.conditions}
              handleAddCondition={(conditionToAdd) =>
                chartTile.handleAddCondition(conditionToAdd, chartTile.data)
              }
              handleChangeCondition={(condition, updatedConditionValue) =>
                chartTile.handleChangeCondition({
                  condition,
                  updatedConditionValue,
                })
              }
              handleDeleteCondition={(condition) =>
                chartTile.handleDeleteCondition(condition)
              }
              handleAddFieldToConditions={(field) =>
                chartTile.handleAddFieldToConditions(field)
              }
              subjectType={chartTile.field_lookup_subject_type}
              topicId={chartTile.topic?.id}
            />
          </div>
        </div>
        <div className="mb-6 py-4">
          <ChartViewSelectors
            chartSettingValues={chartSettingValues}
            chartSettingValuesHandler={chartSettingValuesHandler}
            groupFieldData={groupFieldData}
            kindFieldData={kindFieldData}
            weightFieldData={weightFieldData}
          />
        </div>
      </div>
      <TileWizardActions
        backButtonHandler={backButtonHandler}
        onSaveHandler={saveChartTileSettings}
      />
    </>
  )
}
